import React from "react";
const CustomPlayIcon = () =>{
    return <svg
        width="101"
        height="101"
        viewBox="0 0 101 101"
        version="1.1"
        id="svg2"
        sodipodiDocname="video-play-button.svg"
        inkscapeVersion="1.3 (0e150ed6c4, 2023-07-21)"
        xmlnsInkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlnsSodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsSvg="http://www.w3.org/2000/svg">
        <sodipodiNamedview
            id="namedview2"
            pagecolor="#ffffff"
            bordercolor="#000000"
            borderopacity="0.25"
            inkscapeShowpageshadow="2"
            inkscapePageopacity="0.0"
            inkscapePagecheckerboard="0"
            inkscapeDeskcolor="#d1d1d1"
            inkscapeZoom="11.613861"
            inkscapeCx="50.5"
            inkscapeCy="50.5"
            inkscapeWindow-width="2560"
            inkscapeWindow-height="1369"
            inkscapeWindow-x="3832"
            inkscapeWindow-y="-8"
            inkscapeWindow-maximized="1"
            inkscapeCurrent-layer="svg2" />
        <defs
            id="defs2">
            <filter
                id="Background"
                x="0"
                y="0"
                width="101"
                height="101"
                filterUnits="userSpaceOnUse">
                <feOffset
                    dy="5"
                    input="SourceAlpha"
                    id="feOffset1" />
                <feGaussianBlur
                    stdDeviation="7.5"
                    result="blur"
                    id="feGaussianBlur1" />
                <feFlood
                    floodColor="#0255cc"
                    floodOpacity="0.102"
                    id="feFlood1" />
                <feComposite
                    operator="in"
                    in2="blur"
                    id="feComposite1" />
                <feComposite
                    in="SourceGraphic"
                    id="feComposite2" />
            </filter>
        </defs>
        <g
            id="Play_Button"
            dataName="Play Button"
            transform="translate(-161.5,-345.5)">
            <g
                transform="rotate(-90,304,142.5)"
                filter="url(#Background)"
                id="g2">
                <rect
                    id="Background-2"
                    dataName="Background"
                    width="56"
                    height="56"
                    rx="28"
                    transform="rotate(90,30.5,48)"
                    fill="#ffffff"
                    x="0"
                    y="0" />
            </g>
            <rect
                id="Rectangle_1355"
                dataName="Rectangle 1355"
                width="24"
                height="24"
                transform="translate(195,384)"
                fill="none"
                x="0"
                y="0" />
            <path
                id="Path_28764"
                dataName="Path 28764"
                d="M 25.778,16.087 10.882,8.64 A 1.006,1.006 0 0 0 9.41,9.555 v 14.826 a 1,1 0 0 0 0.99,1.027 1.1,1.1 0 0 0 0.484,-0.114 l 14.892,-7.452 a 0.958,0.958 0 0 0 0,-1.754 z M 23.89,16.965 11.04,23.391 V 10.543 Z"
                transform="translate(191.12,379.029)"
                fill="#0255cc"
                stroke="#0255cc"
                strokeWidth="0.65" />
        </g>
    </svg>

}

export default CustomPlayIcon